import Vue from "vue";

export const isWeiXin = () => {
    let ua = window.navigator.userAgent.toLowerCase();
    if (ua.match(/MicroMessenger/i) == "micromessenger") {
        return true;
    } else {
        return false;
    }
}


export const isPc = () => {
    let userAgent = navigator.userAgent;
    let Agents = [
        "Android",
        "iPhone",
        "SymbianOS",
        "Windows Phone",
        "iPad",
        "iPod",
    ];
    let flag = true;
    for (let v = 0; v < Agents.length; v++) {
        if (userAgent.indexOf(Agents[v]) > 0) {
            flag = false;
            break;
        }
    }
    return flag;
}

export const closePage = () => {
    let userAgent = navigator.userAgent;
    if (isWeiXin()) {
        WeixinJSBridge.call("closeWindow");
    }
    if (!isPc()) {
        window.opener = null;
        window.open("about:blank", "_self", "").close();
    }
    if (
        userAgent.indexOf("Firefox") != -1 ||
        userAgent.indexOf("Chrome") != -1
    ) {
        window.location.href = "about:blank";
    } else {
        window.opener = null;
        window.open("about:blank", "_self");
        window.close();
    }
}


// WEBPACK FOOTER //
// ./src/utils/tool.js